import { leonMediaArray } from './leonMedia'
import { leonBio } from './leonBios'

import { larryReviewerReviewHinge, larryReviewerReviewBumble, larryReviewerReviewTinder } from './leonReviewerReviews'
import { larryReviewerProfile } from './leonReviewers'

export const larryProfileReviewHinge = {
  _id: 'larryProfileReviewHingeId',
  userId: 'leonUserId',
  userEmail: 'leon@email.com',
  datingProfileId: 'leonDatingProfileHingeId',
  reviewerProfileId: 'larryReviewerProfileId',
  reviewerEmail: 'larry@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look incredibly dumb here. Incredibly, incrediblayyy dumb. Though it is authentic, I'll give you that`,
      verdict: 'Somewhat',
    },
    {
      feedback: `House husband to the rescue — great action shot`,
      verdict: 'Yes',
    },
    {
      feedback: `In a durag, scowling, and holding a knife... remember, you're trying to get women you don't know to trust you`,
      verdict: 'No',
    },
    {
      feedback: `OK, I get it.`,
      verdict: 'Yes',
    },
    {
      feedback: `Sure, women like yoga`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Where did this outfit come from!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Latte Larry's! Love the publicity`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `This will exclude all non-Mary Fergusons and might turn off actual Mary Fergusons`,
        verdict: 'No', 
      },
      {
        feedback: `Do people actually know what this is?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `I'll be interested to hear the feedback you get here!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Leon has style and charisma, but in some photos he looks like a total dufus.`,
    good: `The photo in the suit with the hat, the glasses prompt, and the yoga pic`,
    notGood: `The photo where you're holding the knife and most of your captions and prompts`,
    verdict: `Overall the negatives outweigh the positives. Replacing the photos and prompts marked as No or Somewhat will go a long way`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...larryReviewerReviewHinge },
  reviewerProfile: { ...larryReviewerProfile },
  bioItems: { ...leonBio },
  mediaItems: [ ...leonMediaArray ],
}

export const larryProfileReviewBumble = {
  _id: 'larryProfileReviewBumbleId',
  userId: 'leonUserId',
  userEmail: 'leon@email.com',
  datingProfileId: 'leonDatingProfileBumbleId',
  reviewerProfileId: 'larryReviewerProfileId',
  reviewerEmail: 'larry@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look incredibly dumb here. Incredibly, incrediblayyy dumb. Though it is authentic, I'll give you that`,
      verdict: 'Somewhat',
    },
    {
      feedback: `House husband to the rescue — great action shot`,
      verdict: 'Yes',
    },
    {
      feedback: `In a durag, scowling, and holding a knife... remember, you're trying to get women you don't know to trust you`,
      verdict: 'No',
    },
    {
      feedback: `OK, I get it.`,
      verdict: 'Yes',
    },
    {
      feedback: `Sure, women like yoga`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Where did this outfit come from!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: leonBio.aboutMe[0],
    hobbies: [leonBio.hobbies[0], leonBio.hobbies[1], leonBio.hobbies[2], leonBio.hobbies[3], leonBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Latte Larry's! Love the publicity`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'I cannot imagine a woman wanting to date you after reading this',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `This will exclude all non-Mary Fergusons and might turn off actual Mary Fergusons`,
        verdict: 'No', 
      },
      {
        feedback: `Do people actually know what this is?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `I'll be interested to hear the feedback you get here!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Leon has style and charisma, but in some photos he looks like a total dufus.`,
    good: `The photo in the suit with the hat, the glasses prompt, and the yoga pic`,
    notGood: `The photo where you're holding the knife and most of your captions and prompts`,
    verdict: `Overall the negatives outweigh the positives. Replacing the photos and prompts marked as No or Somewhat will go a long way`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...larryReviewerReviewBumble },
  reviewerProfile: { ...larryReviewerProfile },
  bioItems: { ...leonBio },
  mediaItems: [ ...leonMediaArray ],
}

export const larryProfileReviewTinder = {
  _id: 'larryProfileReviewTinderId',
  userId: 'leonUserId',
  userEmail: 'leon@email.com',
  datingProfileId: 'leonDatingProfileTinderId',
  reviewerProfileId: 'larryReviewerProfileId',
  reviewerEmail: 'larry@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: leonMediaArray[3]._id,
      mediaItemURL: leonMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[3].type,
      caption: leonMediaArray[3].captions[1],
      subcaption: leonMediaArray[3].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[0]._id,
      mediaItemURL: leonMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[0].type,
      caption: leonMediaArray[0].captions[1],
      subcaption: leonMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[1]._id,
      mediaItemURL: leonMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[1].type,
      caption: leonMediaArray[1].captions[1],
      subcaption: leonMediaArray[1].subcaptions[1],
    },
    {
      mediaItemId: leonMediaArray[9]._id,
      mediaItemURL: leonMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[9].type,
      caption: leonMediaArray[9].captions[0],
      subcaption: leonMediaArray[9].subcaptions[2],
    },
    {
      mediaItemId: leonMediaArray[8]._id,
      mediaItemURL: leonMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[8].type,
      caption: leonMediaArray[8].captions[2],
      subcaption: leonMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: leonMediaArray[6]._id,
      mediaItemURL: leonMediaArray[6].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: leonMediaArray[6].type,
      caption: leonMediaArray[6].captions[1],
      subcaption: leonMediaArray[6].subcaptions[2],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look incredibly dumb here. Incredibly, incrediblayyy dumb. Though it is authentic, I'll give you that`,
      verdict: 'Somewhat',
    },
    {
      feedback: `House husband to the rescue — great action shot`,
      verdict: 'Yes',
    },
    {
      feedback: `In a durag, scowling, and holding a knife... remember, you're trying to get women you don't know to trust you`,
      verdict: 'No',
    },
    {
      feedback: `OK, I get it.`,
      verdict: 'Yes',
    },
    {
      feedback: `Sure, women like yoga`,
      verdict: 'Yes',
    },
    {
      feedback: `Wow! Where did this outfit come from!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: leonBio._id,
    vitalInfo: { ...leonBio.vitalInfo },
    prompts: [
      { ...leonBio.prompts[0] },
      { ...leonBio.prompts[1] },
      { ...leonBio.prompts[2] }
    ],
    aboutMe: leonBio.aboutMe[0],
    hobbies: [leonBio.hobbies[0], leonBio.hobbies[1], leonBio.hobbies[2], leonBio.hobbies[3], leonBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `Latte Larry's! Love the publicity`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'I cannot imagine a woman wanting to date you after reading this',
      verdict: 'No', 
    },
    promptsFeedback: [
      {
        feedback: `This will exclude all non-Mary Fergusons and might turn off actual Mary Fergusons`,
        verdict: 'No', 
      },
      {
        feedback: `Do people actually know what this is?`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `I'll be interested to hear the feedback you get here!`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Leon has style and charisma, but in some photos he looks like a total dufus.`,
    good: `The photo in the suit with the hat, the glasses prompt, and the yoga pic`,
    notGood: `The photo where you're holding the knife and most of your captions and prompts`,
    verdict: `Overall the negatives outweigh the positives. Replacing the photos and prompts marked as No or Somewhat will go a long way`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...larryReviewerReviewTinder },
  reviewerProfile: { ...larryReviewerProfile },
  bioItems: { ...leonBio },
  mediaItems: [ ...leonMediaArray ],
}